import { Component, OnInit } from '@angular/core';
import { EventService } from '../../controller/event.service';

@Component({
  selector: 'app-event-register',
  templateUrl: './event-register.component.html',
  styles: []
})
export class EventRegisterComponent implements OnInit {
  public showSlotsRemaining:boolean = true
  constructor(public EventController: EventService) { }
  public addressReminder = '';
  ngOnInit() {
  }

  receiveMessage($event) {
    this.addressReminder = $event
  }

  closeModalRegister(){
    this.EventController.dataForm.modalOpen = false
    document.getElementsByTagName("body")[0].style.overflow = "";
  }

}



// WEBPACK FOOTER //
// ./src/app/screens/register-event/view/event-register/event-register.component.ts